import { login, getUserInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    UserInfo: {}, // 用户信息
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    MenuList: [] // 菜单
  },

  mutations: {
    // 设置用户信息
    SET_USER_INFO: (state, data) => {
      state.UserInfo = data
    },
    // 设置菜单
    SET_MENU_LIST: (state, list) => {
      state.MenuList = list
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    RESERT_DATA: (state) => {
      state.UserInfo = {}
      state.token = ''
      state.name = ''
      state.avatar = ''
      state.roles = []
      state.MenuList = [] // 菜单
    }
  },

  actions: {
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          const data = response.token
          setToken(data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfoFn({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_USER_INFO', data)
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.avatar)
          commit('SET_MENU_LIST', response.menus.length > 0 ? response.menus[0].children : [])
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      // return new Promise((resolve, reject) => {
        // logout(state.token).then(() => {
        //   commit('SET_TOKEN', '')
        //   commit('SET_ROLES', [])
        //   removeToken()
        //   resolve()
        // }).catch(error => {
        //   reject(error)
        // })
          // commit('SET_TOKEN', '')
          // commit('SET_ROLES', [])
          commit('RESERT_DATA')
      // })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
